<template>
  <main-layout>
    <template v-if="isMobile">
      <livechat-mobile></livechat-mobile>
    </template>
    <template v-else>
      <livechat></livechat>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Livechat from './Livechat'
import LivechatMobile from './LivechatMobile'
import moment from 'moment'

export default {
  data: () => ({
    isMobile: false,
  }),
  components: {
    Livechat,
    LivechatMobile,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeMount: function () {
    if (
      !(
        (this.selectedBot.pagetype == 'enterprise' &&
          this.$store.state.livechatPageList.includes(this.selectedBot.theme)) ||
        this.$store.state.livechatPageIdList.includes(this.selectedBot.pageid) ||
        (this.selectedBot.theme == 'ecommercebasic' && this.selectedBot.pageid == '270028443161479')
      )
    ) {
      this.$router.push('/' + this.$store.getters.currentLang + '/dashboard')
    }
  },

  mounted() {
    var vm = this
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    if (this.selectedBot.theme == 'universalutilities') {
      vm.$store.dispatch('loadLinePushMessageCount', {
        dateform: moment().startOf('month').format('YYYY-MM-DD'),
        dateto: moment().endOf('month').format('YYYY-MM-DD'),
      })
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 960
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatView.vue